"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  KeepAwake: () => KeepAwake
});
module.exports = __toCommonJS(unavailable_exports);
var import_validate = require("./validate");
function isEnabled() {
  return Promise.resolve(false);
}
function setEnabled(enabled) {
  (0, import_validate.assertKeepAwakeEnabled)(enabled);
  return Promise.resolve();
}
function activate(tag) {
  (0, import_validate.assertKeepAwakeTag)(tag, "activate");
  return Promise.resolve();
}
function deactivate(tag) {
  (0, import_validate.assertKeepAwakeTag)(tag, "deactivate");
  return Promise.resolve();
}
var KeepAwake = Object.freeze({
  isEnabled,
  setEnabled,
  activate,
  deactivate
});
//# sourceMappingURL=unavailable.js.map
